/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, BytesLike, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common.js';
import type { ElementBridge, ElementBridgeInterface } from '../ElementBridge.js';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_rollupProcessor',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_trancheFactory',
        type: 'address',
      },
      {
        internalType: 'bytes32',
        name: '_trancheBytecodeHash',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: '_balancerVaultAddress',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_elementDeploymentValidatorAddress',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'ALREADY_FINALISED',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ASSET_IDS_NOT_EQUAL',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ASSET_NOT_ERC20',
    type: 'error',
  },
  {
    inputs: [],
    name: 'BRIDGE_NOT_READY',
    type: 'error',
  },
  {
    inputs: [],
    name: 'HEAP_EMPTY',
    type: 'error',
  },
  {
    inputs: [],
    name: 'INPUT_ASSETB_NOT_UNUSED',
    type: 'error',
  },
  {
    inputs: [],
    name: 'INTERACTION_ALREADY_EXISTS',
    type: 'error',
  },
  {
    inputs: [],
    name: 'INVALID_CHANGE_IN_BALANCE',
    type: 'error',
  },
  {
    inputs: [],
    name: 'INVALID_POOL',
    type: 'error',
  },
  {
    inputs: [],
    name: 'INVALID_TOKEN_BALANCE_RECEIVED',
    type: 'error',
  },
  {
    inputs: [],
    name: 'INVALID_TRANCHE',
    type: 'error',
  },
  {
    inputs: [],
    name: 'INVALID_WRAPPED_POSITION',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidCaller',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidNonce',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MissingImplementation',
    type: 'error',
  },
  {
    inputs: [],
    name: 'OUTPUT_ASSETB_NOT_UNUSED',
    type: 'error',
  },
  {
    inputs: [],
    name: 'POOL_EXPIRY_MISMATCH',
    type: 'error',
  },
  {
    inputs: [],
    name: 'POOL_NOT_FOUND',
    type: 'error',
  },
  {
    inputs: [],
    name: 'POOL_UNDERLYING_MISMATCH',
    type: 'error',
  },
  {
    inputs: [],
    name: 'RECEIVED_LESS_THAN_LIMIT',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TRANCHE_ALREADY_EXPIRED',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TRANCHE_EXPIRY_MISMATCH',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TRANCHE_POSITION_MISMATCH',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TRANCHE_UNDERLYING_MISMATCH',
    type: 'error',
  },
  {
    inputs: [],
    name: 'UNREGISTERED_PAIR',
    type: 'error',
  },
  {
    inputs: [],
    name: 'UNREGISTERED_POOL',
    type: 'error',
  },
  {
    inputs: [],
    name: 'UNREGISTERED_POSITION',
    type: 'error',
  },
  {
    inputs: [],
    name: 'VAULT_ADDRESS_MISMATCH',
    type: 'error',
  },
  {
    inputs: [],
    name: 'VAULT_ADDRESS_VERIFICATION_FAILED',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'nonce',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalInputValue',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'int64',
        name: 'gasUsed',
        type: 'int64',
      },
    ],
    name: 'LogConvert',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'nonce',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'success',
        type: 'bool',
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'message',
        type: 'string',
      },
      {
        indexed: false,
        internalType: 'int64',
        name: 'gasUsed',
        type: 'int64',
      },
    ],
    name: 'LogFinalise',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'poolAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'wrappedPositionAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint64',
        name: 'expiry',
        type: 'uint64',
      },
    ],
    name: 'LogPoolAdded',
    type: 'event',
  },
  {
    inputs: [],
    name: 'ROLLUP_PROCESSOR',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SUBSIDY',
    outputs: [
      {
        internalType: 'contract ISubsidy',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'assetToExpirys',
    outputs: [
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'computeCriteria',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: 'inputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: 'inputAssetB',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: 'outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: 'outputAssetB',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: 'totalInputValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'interactionNonce',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: 'auxData',
        type: 'uint64',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'convert',
    outputs: [
      {
        internalType: 'uint256',
        name: 'outputValueA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'outputValueB',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isAsync',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: 'outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: 'interactionNonce',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'finalise',
    outputs: [
      {
        internalType: 'uint256',
        name: 'outputValueA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'outputValueB',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'interactionCompleted',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address',
      },
    ],
    name: 'getAssetExpiries',
    outputs: [
      {
        internalType: 'uint64[]',
        name: 'assetExpiries',
        type: 'uint64[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'interactionNonce',
        type: 'uint256',
      },
    ],
    name: 'getTrancheDeploymentBlockNumber',
    outputs: [
      {
        internalType: 'uint256',
        name: 'blockNumber',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address',
      },
      {
        internalType: 'uint64',
        name: 'expiry',
        type: 'uint64',
      },
    ],
    name: 'hashAssetAndExpiry',
    outputs: [
      {
        internalType: 'uint256',
        name: 'hashValue',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'interactions',
    outputs: [
      {
        internalType: 'uint256',
        name: 'quantityPT',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'trancheAddress',
        type: 'address',
      },
      {
        internalType: 'uint64',
        name: 'expiry',
        type: 'uint64',
      },
      {
        internalType: 'bool',
        name: 'finalised',
        type: 'bool',
      },
      {
        internalType: 'bool',
        name: 'failed',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'pools',
    outputs: [
      {
        internalType: 'bytes32',
        name: 'poolId',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'trancheAddress',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'poolAddress',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'wrappedPositionAddress',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_convergentPool',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_wrappedPosition',
        type: 'address',
      },
      {
        internalType: 'uint64',
        name: '_expiry',
        type: 'uint64',
      },
    ],
    name: 'registerConvergentPoolAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

type ElementBridgeConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: ElementBridgeConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class ElementBridge__factory extends ContractFactory {
  constructor(...args: ElementBridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _rollupProcessor: PromiseOrValue<string>,
    _trancheFactory: PromiseOrValue<string>,
    _trancheBytecodeHash: PromiseOrValue<BytesLike>,
    _balancerVaultAddress: PromiseOrValue<string>,
    _elementDeploymentValidatorAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<ElementBridge> {
    return super.deploy(
      _rollupProcessor,
      _trancheFactory,
      _trancheBytecodeHash,
      _balancerVaultAddress,
      _elementDeploymentValidatorAddress,
      overrides || {},
    ) as Promise<ElementBridge>;
  }
  override getDeployTransaction(
    _rollupProcessor: PromiseOrValue<string>,
    _trancheFactory: PromiseOrValue<string>,
    _trancheBytecodeHash: PromiseOrValue<BytesLike>,
    _balancerVaultAddress: PromiseOrValue<string>,
    _elementDeploymentValidatorAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(
      _rollupProcessor,
      _trancheFactory,
      _trancheBytecodeHash,
      _balancerVaultAddress,
      _elementDeploymentValidatorAddress,
      overrides || {},
    );
  }
  override attach(address: string): ElementBridge {
    return super.attach(address) as ElementBridge;
  }
  override connect(signer: Signer): ElementBridge__factory {
    return super.connect(signer) as ElementBridge__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ElementBridgeInterface {
    return new utils.Interface(_abi) as ElementBridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ElementBridge {
    return new Contract(address, _abi, signerOrProvider) as ElementBridge;
  }
}
